import SectionHeading from './SectionHeading';
import { tvSeries } from '@/mocks/tvSeries';

export default function TvSeries() {
  return (
    <section id="tv" className="scroll-mt-16 bg-background-100 py-14 md:py-20 border-t border-background-200/70">
      <div className="px-4 md:px-8">
        <SectionHeading
          icon="ri-tv-2-line"
          eyebrow="电视剧专区"
          title="电视剧：按题材与更新状态整理的剧集清单"
          desc="这里按刑侦、年代、古装、科技等题材列出剧集条目，并给出总集数、更新状态与一句看点。信息密度较高，适合快速比对后挑一部开始看。"
          tone="accent"
        />

        <div className="mt-8 rounded-lg border border-background-200 bg-background-50 overflow-hidden">
          <div className="hidden lg:grid grid-cols-12 gap-4 px-5 py-3 bg-secondary-100 text-xs font-medium tracking-wide text-secondary-900">
            <span className="col-span-2">剧名</span>
            <span className="col-span-2">类型</span>
            <span className="col-span-1">集数</span>
            <span className="col-span-2">状态</span>
            <span className="col-span-5">看点</span>
          </div>

          <div className="divide-y divide-background-200">
            {tvSeries.map((row) => (
              <div
                key={row.id}
                className="grid grid-cols-1 lg:grid-cols-12 gap-2 lg:gap-4 px-4 lg:px-5 py-4 transition-colors hover:bg-primary-50"
              >
                <div className="lg:col-span-2 flex items-center gap-2">
                  <span className="flex items-center justify-center w-6 h-6 rounded-md bg-primary-100 text-primary-700">
                    <i className="ri-play-fill text-xs"></i>
                  </span>
                  <span className="font-heading text-sm font-bold text-foreground-950">{row.title}</span>
                </div>
                <div className="lg:col-span-2 text-xs text-foreground-600 lg:self-center">{row.genre}</div>
                <div className="lg:col-span-1 text-xs text-foreground-600 lg:self-center">{row.episodes} 集</div>
                <div className="lg:col-span-2 lg:self-center">
                  <span
                    className={`inline-block px-2 py-0.5 text-xs rounded-md ${
                      row.status.includes('更新')
                        ? 'bg-accent-100 text-accent-800'
                        : 'bg-background-200 text-foreground-700'
                    }`}
                  >
                    {row.status}
                  </span>
                </div>
                <div className="lg:col-span-5 text-xs leading-5 text-foreground-600">{row.highlight}</div>
              </div>
            ))}
          </div>
        </div>

        <p className="mt-4 text-xs text-foreground-500">
          说明：以上条目按题材与更新状态归类展示，集数与状态会随剧集进度变化，仅供参考。
        </p>
      </div>
    </section>
  );
}